const MONTHS = {
  en: [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ],
  fr: [
    "Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
    "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"
  ]
}

export function formatDateSafely(dateValue: any, language: string, fallback = ""): string {
  if (!dateValue) return fallback
  try {
    let date: Date
    if (dateValue instanceof Date) {
      date = new Date()
      date.setUTCFullYear(dateValue.getUTCFullYear())
      date.setUTCMonth(dateValue.getUTCMonth())
      date.setUTCDate(dateValue.getUTCDate())
      date.setUTCHours(0, 0, 0, 0)
    } else if (typeof dateValue === "string") {
      const dateOnly = dateValue.split('T')[0]
      const [year, month, day] = dateOnly.split('-').map(Number)
      date = new Date()
      date.setUTCFullYear(year)
      date.setUTCMonth(month - 1)
      date.setUTCDate(day)
      date.setUTCHours(0, 0, 0, 0)
    } else {
      return fallback
    }
    if (isNaN(date.getTime())) {
      return fallback
    }
    const lang = language.startsWith('fr') ? 'fr' : 'en'
    const dd = String(date.getUTCDate()).padStart(2, '0')
    const mon = MONTHS[lang][date.getUTCMonth()].slice(0, 3)
    const yyyy = date.getUTCFullYear()
    return `${dd} ${mon} ${yyyy}`
  } catch (error) {
    console.warn(`Error formatting date "${dateValue}":`, error)
    return fallback
  }
}

export function formatDateOnly(dateValue: string | null | undefined, language: string): string {
  if (!dateValue) return '';
  const dateOnly = dateValue.split('T')[0];
  const [year, month, day] = dateOnly.split('-');
  if (language === 'fr') {
    return `${day}-${month}-${year}`;
  }
  return `${month}-${day}-${year}`;
}

export function formatDateTime(dateValue: string, language: string): string {
  if (!dateValue) return '';
  try {
    const date = new Date(dateValue);
    if (isNaN(date.getTime())) return '';

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const isFrench = language === 'fr';

    const time = date.toLocaleTimeString(isFrench ? 'fr-FR' : 'en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: !isFrench,
    });

    if (isFrench) {
      return `${day}-${month}-${year} ${time}`;
    }
    return `${month}-${day}-${year} ${time}`;
  } catch (error) {
    console.warn('Error formatting datetime:', error);
    return '';
  }
}

export function formatRate(value: number | null | undefined): string {
  if (value === null || value === undefined) return '';
  return new Intl.NumberFormat('en-CA', { style: 'currency', currency: 'CAD' }).format(value);
}
